const JSZip = require("jszip");

export const loadSecureZip = async (blob: Blob): Promise<typeof JSZip> => {
  const zip = await JSZip.loadAsync(blob);
  const maxFiles = 100;
  const maxTotalUncompressedSize = 50 * 1024 * 1024; // 50 MB
  const maxCompressionRatio = 40;

  const zipFiles = Object.keys(zip.files);
  if (zipFiles.length > maxFiles) {
    throw new Error(`ZIP contains too many files: ${zipFiles.length}`);
  }

  let totalUncompressedSize = 0;
  for (const fileName of zipFiles) {
    const file = zip.files[fileName];

    // Sanitize file paths
    if (fileName.includes("..") || fileName.startsWith("/") || fileName.startsWith("\\")) {
      throw new Error(`Dangerous file path in ZIP: ${fileName}`);
    }

    // Validate file extensions
    const allowedExtensions = /\.(pdf|csv)$/i;
    if (!allowedExtensions.test(fileName)) {
      throw new Error(`Unsupported file type in ZIP: ${fileName}`);
    }

    // Calculate uncompressed size
    const uncompressedData = await file.async("uint8array");
    const uncompressedSize = uncompressedData.length;
    totalUncompressedSize += uncompressedSize;

    // Calculate compression ratio
    const compressedSize = file._data.compressedSize;
    const compressionRatio = uncompressedSize / compressedSize;
    if (compressionRatio > maxCompressionRatio) {
      throw new Error(`Abnormal compression ratio in file: ${fileName}`);
    }
  }

  if (totalUncompressedSize > maxTotalUncompressedSize) {
    throw new Error(`Total uncompressed size exceeds limit: ${totalUncompressedSize}`);
  }

  return zip;
};
